var _rect, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F0F0F0",
    rx: 11
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "dzr87oyzza",
    width: 14,
    height: 22,
    x: 13,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13 9h13.415v22H13V9z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dzr87oyzza)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    fillRule: "evenodd",
    d: "M26.378 18.425c-.147.683-.756.952-1.392.952-1.66 0-3.248-.415-4.664-1.22v2.588c2.199 2.587 3.907 5.396 4.835 8.668.196.634-.195 1.342-.831 1.514-.633.195-1.342-.196-1.513-.83-.659-2.345-1.758-4.494-3.223-6.398-.758 2.149-1.709 4.249-2.858 6.275l-.243.416c-.22.39-.634.61-1.05.61-.22 0-.415-.073-.61-.172-.586-.316-.805-1.073-.464-1.66l.243-.414c1.393-2.442 2.491-5.03 3.273-7.716v-2.93c-1.025.903-1.905 1.953-2.613 3.125-.367.61-1.22.782-1.783.342-.488-.391-.633-1.074-.318-1.612 1.296-2.149 3.102-3.955 5.25-5.25.464-.316 1.124-.267 1.538.147 1.345 1.343 3.127 2.075 5.031 2.075h.22c.756 0 1.368.733 1.172 1.49zm-7.276-9.424c1.347 0 2.441 1.092 2.441 2.44 0 1.35-1.094 2.442-2.44 2.442-1.35 0-2.443-1.092-2.443-2.441C16.66 10.092 17.753 9 19.102 9z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAccess);
export default __webpack_public_path__ + "static/media/small_access.4b4c4a0c52545ccafbec3a294d81d448.svg";
export { ForwardRef as ReactComponent };